module.exports = __webpack_public_path__ + "media/images/landing__eventPrize__prize1-09d611630061892610a38a555be6b135.jpg";